/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getHelpArticle} from '../api'

 export const useQueryGetHelpArticle = createReactQueryHook('getHelpArticle', getHelpArticle)
